export const UNASSIGNED = 'Unassigned'
export const UNASSIGN_SIGNAL = null
export const NO_PREFERENCE = 'No Preference'
export const PAGINATION_LIMIT_DEFAULT = 25
